import React from 'react';

const LoadingSpinner = ({ size = 'md', fullScreen = true }) => {
  const spinner = (
    <div className="relative flex items-center justify-center" style={{ width: 56, height: 56 }}>
      {/* Outer ring — fast */}
      <div
        className="absolute inset-0 rounded-full"
        style={{
          border: '3px solid transparent',
          borderTopColor: '#d4922a',
          borderRightColor: '#d4922a',
          animation: 'ls-spin 0.55s linear infinite',
        }}
      />
      {/* Middle ring — fast reverse */}
      <div
        className="absolute rounded-full"
        style={{
          inset: 8,
          border: '3px solid transparent',
          borderTopColor: '#e9c478',
          borderLeftColor: '#e9c478',
          animation: 'ls-spin-rev 0.7s linear infinite',
        }}
      />

      <style>{`
        @keyframes ls-spin     { to { transform: rotate(360deg);  } }
        @keyframes ls-spin-rev { to { transform: rotate(-360deg); } }
      `}</style>
    </div>
  );

  if (!fullScreen) return spinner;

  return (
    <div className="flex-grow flex items-center justify-center min-h-[40vh]">
      {spinner}
    </div>
  );
};

export default LoadingSpinner;
